import {Directive, HostListener, ElementRef} from '@angular/core';

@Directive({
    selector: '[ssgHogClick]'
})
export class HogClickDirective {
    constructor(private elementRef: ElementRef) {
    }

    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent): void {
        event.stopPropagation();
    }
}
